import posthog, { type Properties } from 'posthog-js';

export function sendPosthogEvent(event: string, prefix: string = '', properties: Properties = {}) {
  posthog.capture(`${prefix}${event}`, properties);
}
